/**
 * Local override — copy from config.example.js.
 * clientId is filled after Azure app registration (see README).
 */
export const config = {
  clientId: "8dd42012-bdbe-4e17-a12b-70e433e31147",
  paperReaderFolder: "Projeler/PaperReader",
  // Consumer OneDrive on this Mac is OneDrive-Personal (live.net)
  authority: "https://login.microsoftonline.com/consumers",
  /** Must match Azure → Authentication → SPA redirect URI exactly.
   * Azure SPA list must include BOTH:
   *   - http://localhost:5173/
   *   - https://paper-reader-mobile.pages.dev/
   */
  redirectUri: "https://paper-reader-mobile.pages.dev/",
  /** Optional: pre-fill Microsoft login email (Personal OneDrive account) */
  loginHint: "",
};
